import {
  accountIdentity,
  anyAccountId,
  avcoreStreamApiCredentials,
  roomContextId,
  roomId,
  streamId,
  streamIsActive,
  streamKinds
} from "@common/domain";

export const roomStreamToPublishVORaw = {
  type: "object",
  required: [
    "accountId",
    "accountIdentity",
    "roomId",
    "roomContextId",
    "streamIsActive",
    "streamId",
    "streamKinds",
    "credentials"
  ],
  properties: {
    accountId: anyAccountId,
    accountIdentity,
    roomId,
    roomContextId,
    streamIsActive,
    streamId,
    streamKinds,
    credentials: avcoreStreamApiCredentials
  },
  additionalProperties: false
};
